import type Alpine from "alpinejs"

import { copyToClipboard } from "~/src/lib/clipboard"

export default function (alpine: typeof Alpine) {
  alpine.magic("clipboard", () => copyToClipboard)
}
